export const ru = {
    banners: 'Объявления',
    'banners-1': 'объявления',
    'banners-2': 'объявлений',
    'banners-5': 'объявлений',
    'banners-loading-failed': 'Не удалось загрузить объявления',
    bannersPartial: 'Превью {count} {banners} из {totalCount}',
    'go-to-banners': 'Перейти к объявлениям группы',
    'no-banners-available': 'Баннеры для фразы не найдены'
};
